import { takeEvery, put, call, take} from "redux-saga/effects"
import * as Sentry from "@sentry/browser";
// @ts-ignore
import upperFirst from "lodash/upperFirst"

// @ts-ignore
import { store } from 'store'
import { IHandlesShowModalsWithImageCropper, IShowModalWithImageCropper } from "./interfaces"
// @ts-ignore
import ImageCropper from 'app/components/ImageCropper'
// @ts-ignore
import { modal } from 'store/entities/modal/actions'
// @ts-ignore
import { uploadActivityImage, trigerShowModalsWithImageCropper } from 'store/entities/protracks/activities/actions'
// @ts-ignore
import { ACTIVITY_IMAGE, GALLERY_S3_ENTITY } from 'app/constants/gallery'
// @ts-ignore
import { showWarning } from 'store/entities/toastr/utils'
import { showMessageForUploadImages } from 'helpers/showMessage'


export default function* showModalsWithImageCropperSaga() {
  yield takeEvery(trigerShowModalsWithImageCropper, handlesShowModalsWithImageCropper)
}

export function* showModalWithImageCropper({ file, imageDomainId, outputWidth, outputHeight, renderWidth, renderHeight, scale, entityName }: IShowModalWithImageCropper) {
  try {
    yield put(
      modal.show(ImageCropper, {
        outputWidth,
        outputHeight,
        renderWidth,
        renderHeight,
        scale,
        file,
        title: `Position and size ${upperFirst(entityName)}`,
        isModal: true,
        isShowCancelButton: false,
        onSave: (
          canvas: HTMLCanvasElement,
          canvasScaled: HTMLCanvasElement,
          scale: number
        ) => {
          const mime = scale < 100 ? 'image/png' : file.type
          const canvasFileName = file.name
          const fileResolution = `${canvasScaled.width}x${canvasScaled.height}`
          store.dispatch(uploadActivityImage(canvasScaled, fileResolution, imageDomainId, GALLERY_S3_ENTITY[ACTIVITY_IMAGE], mime, canvasFileName))
          modal.hide()
        },
        onCancel: () => {
          modal.hide()
        },
        size: 'sm'
      })
    )
  } catch(error) {
    Sentry.withScope(scope => {
      scope.setExtra('where error was happen', `showModalWithImageCropper at showModalsWithImageCropperSaga with file ${file.name}`)
      Sentry.captureException(error)
    })
    showWarning()
  }
}

export function* handlesShowModalsWithImageCropper({ payload }: IHandlesShowModalsWithImageCropper) {
  const { arrOfImageForCropp, lengthOfFileList ,lengthOfErrorList , imageInputProps } = payload
  let errorsCounter = lengthOfErrorList
  const { outputWidth, outputHeight, renderWidth, renderHeight, scale } = imageInputProps.cropper
  const { entityName } = imageInputProps
  try {
    let i = 0
    while (i < arrOfImageForCropp.length) {
      const { file, imageDomainId } = arrOfImageForCropp[i]
      yield call(showModalWithImageCropper, { file, imageDomainId, outputWidth, outputHeight, renderWidth, renderHeight, scale, entityName })
      yield take(modal.hide)
      i++
    }
  } catch (error) {
    errorsCounter++
    showWarning()
  } finally {
    showMessageForUploadImages (lengthOfFileList, errorsCounter)
  }
}

